module.exports = __webpack_public_path__ + "static/media/font_regular.48020f9a.woff2";